// @flow
// TODO: Upgrade Flow to a version that supports React hooks
// $FlowFixMeimport
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Block from 'brastrap/editorial/block/Block';
import Link from 'brastrap/containers/link/LinkContainer';
import MarkDown from 'brastrap/editorial/markdown/Markdown';
import Accordion from 'brastrap/common/accordion/Accordion';
import type { HelpBlock as Props } from './help-block.types.js';

const HelpBlock = (props: Props) => {
  const [activeAccordion, setActiveAccordion] = useState(null);

  let linkList;
  const title = !props.showAsAccordions
    ? (props.helpTopic && props.helpTopic.name) || props.name
    : '';

  if (props.helpTopic && props.helpTopic.faqs) {
    const limit = 3;
    linkList = props.helpTopic.faqs
      .slice(0, props.helpTopic.featuredFaqs || limit)
      .map((faq, index) => (
        <li key={index}>
          <Link href={faq.faqLink} alt={faq.question}>
            {faq.question}
          </Link>
        </li>
      ));
  } else {
    linkList = props.faqLinks.map((faq, index) => (
      <li key={index}>
        <Link href={faq.faqLink} alt={faq.question}>
          {faq.question}
        </Link>
      </li>
    ));
  }
  return (
    <Block {...props} title={title} modifiers={props.modifiers}>
      {!props.showAsAccordions && <ul>{linkList}</ul>}
      {!props.showAsAccordions && props.helpTopic && props.helpTopic.allFaqs && (
        <Link href={props.helpTopic.topicLink}>
          <strong>
            <FormattedMessage
              id="faqs.see-all-FAQS"
              defaultMessage="See all FAQs"
            />
          </strong>
        </Link>
      )}

      {props.showAsAccordions && (
        <div className="s-prose">
          <h2
            style={{
              fontFamily: 'Editors Note',
              fontSize: '1.5rem',
              color: '#46433F',
              textAlign: 'left',
              fontWeight: 100,
            }}
          >
            {props.helpTopic.name}
          </h2>
          <Accordion activeChild={activeAccordion}>
            {props.helpTopic.faqs.map(faq => (
              <Accordion.Item
                id={faq.id}
                label={faq.question}
                key={faq.id}
                onClick={() => setActiveAccordion(faq.id)}
              >
                <MarkDown content={faq.answer} />
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      )}
    </Block>
  );
};

HelpBlock.defaultProps = {
  faqLinks: [],
  modifiers: [],
  showAsAccordions: false,
};

export default HelpBlock;
